import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Timekiwi - delicious timelines",
  "description": "",
  "published": "2011-11-10T00:00:00.000Z",
  "redirect_from": ["/blog/timekiwi-delicious-timelines/swizec/2900"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/11/Screen-Shot-2011-11-10-at-12.23.46-PM-240x300.png",
        "alt": "Timekiwi vertical timeline",
        "title": "Timekiwi vertical timeline"
      }}></img></p>
    <p><a parentName="p" {...{
        "href": "http://timekiwi.com/"
      }}>{`Timekiwi`}</a>{` is a beautiful new tool that lets you create a timeline of your social life in a single easy to digest interface.`}</p>
    <p>{`Right now six services are supported: Twitter, Facbook, Tumblr, Foursquare, Instagram and Flickr. Just clicky click and a shiny timeline is waiting for you to behold. I was lucky enough to see the beta version, which had even more flare about it - instead of creating a timeline you squeezed kiwis. That was a nice touch :)`}</p>
    <p>{`Since I don't have Facebook timelines yet I can't quite compare with that, but what I can do is compare with `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/lifepath-me-is-the-shiniest-web-thing/swizec/1848",
        "title": "Lifepath.me is the shiniest web thing"
      }}>{`lifepath.me `}</a>{`... although I'm not sure how lively that project is anymore since @dcurtis sold it as soon as facebook announced its timelines.`}</p>
    <p>{`Conceptually I believe timekiwi is much closer to facebook's timelines than it is to lifepath since it's meant as a display of your meaningful tweets (no retweets or conversations) and photos to dial the flare up to eleven. Whereas lifepath was more about putting significant events in your life on a timeline without aggregation.`}</p>
    <p>{`Anyway, I shall shut up now and let you bask in the glory of some screenshots of `}<a parentName="p" {...{
        "href": "http://timekiwi.com/"
      }}>{`Timekiwi`}</a>{`.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/11/Screen-Shot-2011-11-10-at-12.22.54-PM-1024x698.png",
        "alt": "Timekiwi entry page",
        "title": "Timekiwi entry page"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/11/Screen-Shot-2011-11-10-at-12.23.46-PM.png",
        "alt": "Timekiwi vertical timeline",
        "title": "Timekiwi vertical timeline"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/11/Screen-Shot-2011-11-10-at-12.24.26-PM-1024x567.png",
        "alt": "Timekiwi horizontal timeline",
        "title": "Timekiwi horizontal timeline"
      }}></img></p>
    <p>{`What're you waiting for? `}<a parentName="p" {...{
        "href": "http://timekiwi.com"
      }}>{`Go get a timekiwi`}</a>{`!`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://thenextweb.com/apps/2011/10/30/create-a-gorgeous-social-media-timeline-using-timekiwi/"
        }}>{`Create a gorgeous social media timeline using Timekiwi`}</a>{` (thenextweb.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.techmadly.com/create-awesome-social-media-timeline-with-timekiwi"
        }}>{`Create Awesome Social Media Timeline With Timekiwi`}</a>{` (techmadly.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://blogs.journalism.co.uk/2011/11/01/tool-of-the-week-for-journalists-timekiwi-to-create-social-media-timelines/"
        }}>{`Tool of the week for journalists - TimeKiwi, to create social media timelines`}</a>{` (blogs.journalism.co.uk)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.makeuseof.com/tag/cool-websites-tools-october-22nd-2011/"
        }}>{`Cool Websites and Tools `}{`[`}{`October 22nd 2011`}{`]`}</a>{` (makeuseof.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=0e212a92-7e3d-4add-8481-02c25fcb6c3d",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      